import React, {useState, useEffect} from 'react'
import {matchPath, useHistory, useLocation} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import Routes from '../../constants/RouteConstants'
import {Grid} from '@mui/material'
import Constant from './AmenitiesConstants'
import PageHeader from '../PageHeader'
import Loader from '../Loader'
import {loadAmenitiesForBuilding} from '../../actions/amenitiesActions'
import RXRButton from '../RXRButton'
import {PageContainer} from '../../assets/styles/layout'
import {AntTab, AntTabs} from '../AntTabs'
import AllAmenitiesCalendarView from './AllAmenitiesCalendarView'
import IndividualAmenityCalendarView from './IndividualAmenityCalendarView'
import {rxrContainerColor} from '../../assets/styles/color'
import {makeStyles} from '@mui/styles'
import SidePanel from '../SidePanel'
import AmenityReservationEditor from './AmenityReservationEditor'
import {selectActiveBuildingAndSisterBuildingIds} from '../../reducers/selectors'

const TAB_ALL = 0
const TAB_SINGLE = 1
const tabRoutes = [Routes.RECREATIONAL_AMENITIES_CALENDAR_VIEW, Routes.RECREATIONAL_AMENITIES_CALENDAR_VIEW_INDIVIDUAL]

const nonOnboardingFilter = a => !a.isOnboardingOnly

function CalendarViewPage(props) {
  const isMobile = useSelector(state => state.App.isMobile)
  const classes = useStyles()
  const [isLoadingAmenityData, setIsLoadingAmenityData] = useState(true)

  const buildingIds = useSelector(selectActiveBuildingAndSisterBuildingIds)
  const history = useHistory()
  const currentLocation = useLocation()
  const dispatch = useDispatch()
  const individualMatch = matchPath(currentLocation.pathname, Routes.RECREATIONAL_AMENITIES_CALENDAR_VIEW_INDIVIDUAL)
  let isCreateMode = false
  let createMatch = matchPath(currentLocation.pathname, {path: Routes.RECREATIONAL_AMENITIES_RESERVATIONS_CALENDAR_VIEW_CREATE})
  if (createMatch && createMatch.isExact) {
    isCreateMode = true
  }
  const tab = individualMatch ? TAB_SINGLE : TAB_ALL

  useEffect(() => {
    loadAmenitiesForBuilding(dispatch, buildingIds).then(() => setIsLoadingAmenityData(false))
  }, [])

  return (
    <div style={PageContainer}>
      <PageHeader
        title={Constant.RECREATIONAL_RESERVATION_CALENDAR}
        rightControlComponent={
          <RXRButton
            type={isMobile ? RXRButton.TYPE_DEFAULT : RXRButton.TYPE_LARGE}
            onClick={() => history.push(Routes.RECREATIONAL_AMENITIES_RESERVATIONS_CALENDAR_VIEW_CREATE)}
          >
            {Constant.BTN_ADD}
          </RXRButton>
        }
      >
        <Grid container>
          <Grid item lg={6} md={6}>
            <AntTabs value={tab} onChange={(e, t) => history.push(tabRoutes[t])}>
              <AntTab label={'All amenities'} />
              <AntTab label={'Individual amenity'} />
            </AntTabs>
          </Grid>
        </Grid>
      </PageHeader>

      <div className={classes.mainContainer}>
        {isLoadingAmenityData ? (
          <Loader />
        ) : tab === TAB_ALL ? (
          <AllAmenitiesCalendarView amenitiesFilter={nonOnboardingFilter} />
        ) : (
          <IndividualAmenityCalendarView
            amenitiesFilter={nonOnboardingFilter}
            individualAmenityRoute={Routes.RECREATIONAL_AMENITIES_CALENDAR_VIEW_INDIVIDUAL_AMENITY}
          />
        )}
      </div>
      <SidePanel
        isOpen={!!isCreateMode}
        onClose={() => history.push(Routes.RECREATIONAL_AMENITIES_CALENDAR_VIEW)}
        title={'Make a reservation'}
      >
        <AmenityReservationEditor
          onComplete={() => history.push(Routes.RECREATIONAL_AMENITIES_CALENDAR_VIEW)}
          amenitiesFilter={a => !a.isOnboardingOnly}
        />
      </SidePanel>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  mainContainer: {
    backgroundColor: rxrContainerColor,
    flex: 1,
    width: '100%',
    overflowX: 'auto',
  },
}))

export default CalendarViewPage
